import { OffsetMaterials, Materials } from '@consts/materials';
import { Box, Slider, Typography } from '@mui/material';

const MODEL_STEPS: {
    productIds: number[];
    step: number;
    min: number;
    max: number;
    material: Partial<Record<Materials, { default: number }>>;
    range: string;
}[] = [
    {
        productIds: [4400],
        step: 1,
        min: -20,
        max: 20,
        material: {
            [Materials.Matte]: { default: 25 },
            [Materials.Original]: { default: 25 },
            [Materials.StyleSkins]: { default: 25 },
            [Materials.Privacy]: { default: 25 },
            [Materials.Fusion]: { default: 31 },
        },
        range: '1-40',
    },
    {
        productIds: [67],
        step: 5,
        min: -200,
        max: 200,
        material: {
            [Materials.Matte]: { default: 250 },
            [Materials.Original]: { default: 250 },
            [Materials.StyleSkins]: { default: 250 },
            [Materials.Privacy]: { default: 250 },
            [Materials.Fusion]: { default: 310 },
        },
        range: '1-1000',
    },
    {
        productIds: [10],
        step: 1,
        min: -40,
        max: 40,
        material: {
            [Materials.Matte]: { default: 36 },
            [Materials.Original]: { default: 36 },
            [Materials.StyleSkins]: { default: 36 },
            [Materials.Privacy]: { default: 36 },
            [Materials.Fusion]: { default: 75 },
        },
        range: '1-100',
    },
];

type ForceMaterials = Record<
    string,
    {
        materials: Record<
            string,
            {
                forceOffset: number;
            }
        >;
    }
> | null;

export const ForceMaterials = ({
    state,
    productId,
    unlocked,
    dispatch,
}: {
    productId: string;
    unlocked: boolean;
    state: ForceMaterials;
    dispatch: (value: ForceMaterials) => void;
}) => {
    const stepMap = MODEL_STEPS.find((step) => step.productIds.includes(parseInt(productId!))) || MODEL_STEPS[0];

    return (
        <>
            <Box display={'flex'} flexDirection={'row'}>
                <Typography>Total Force Range is {stepMap.range}</Typography>
            </Box>

            {Object.entries(OffsetMaterials).map(([name, id]) => {
                const forceOffset = (productId ? state![productId]?.materials[id]?.forceOffset : 0) || 0;

                return (
                    <Box display={'flex'} flexDirection={'row'} key={`${name} - ${id}`}>
                        <Box display={'flex'} flexDirection={'column'}>
                            <Typography fontWeight='bold' width={'120px'}>
                                {name}
                            </Typography>
                            <Typography>Offset #: {forceOffset}</Typography>
                            <Typography sx={{ opacity: 0.7 }}>
                                Default #: {(stepMap.material as any)[name]?.default}
                            </Typography>
                            <Typography sx={{ opacity: 0.7 }}>
                                Total Force #: {(stepMap.material as any)[name]?.default + forceOffset}
                            </Typography>
                        </Box>

                        <Slider
                            disabled={!unlocked}
                            value={forceOffset}
                            onChange={(_, value) =>
                                dispatch({
                                    ...state,
                                    [productId!]: {
                                        materials: {
                                            ...(state![productId!] || {})!.materials,
                                            [id]: { forceOffset: value },
                                        },
                                    },
                                })
                            }
                            min={stepMap.min}
                            max={stepMap.max}
                            marks={[
                                { label: `min: -${stepMap.min}`, value: stepMap.min },
                                { label: `max: +${stepMap.max}`, value: stepMap.max },
                            ]}
                            valueLabelFormat={(value) => `${name}: ${value}`}
                            valueLabelDisplay='auto'
                            sx={{ ml: '20px' }}
                            step={stepMap.step}
                        />
                    </Box>
                );
            })}
        </>
    );
};
